import { VARIATION_DIALOG_MESSAGES, VariationDialogMessages } from "./variations-dialog.messages";
import { VARIATION_FILTER_MESSAGES, VariationFilterMessages } from "./variations-filter.messages";
import { VARIATION_STATUS_MESSAGES, VariationStatusMessages } from "./variations-status.messages";
import { VARIATIONS_TABLE_MESSAGES, VariationsTableMessages } from "./variations-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type VariationsMessages = SidebarMessages &
  PopoverMessages &
  ActionButtonMessages &
  VariationFilterMessages &
  VariationsTableMessages &
  VariationDialogMessages &
  VariationStatusMessages & {
    pageTitle: string;
    variationTableTitle: string;
    breadCrumbTitle: string;

    addVariationButton: string;
  };

export const VARIATIONS_MESSAGES: VariationsMessages = {
  pageTitle: "Variações",
  variationTableTitle: "Variações",
  breadCrumbTitle: "Variações",

  addVariationButton: "Nova Variação",

  ...VARIATION_STATUS_MESSAGES,
  ...VARIATION_DIALOG_MESSAGES,
  ...VARIATIONS_TABLE_MESSAGES,
  ...VARIATION_FILTER_MESSAGES,
  ...POPOVER_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default VARIATIONS_MESSAGES;
